export default class BrochureButton {
    constructor() {
        this.id = 'getBrochureButton';
    }

    getHtml() {
        const styles = 'class="btn btn--yellow btn--width-100 btn--48-lg loading"';
        return `<button data-qa="get-brochure-button" id="${this.id}" ${styles}>Get Brochure</button>`;
    }

    getNode() {
        return document.getElementById(this.id);
    }
}
